<svelte:options customElement="hb-dropdown-simple" />

<script lang="ts">
  /**
   * Svelte Simple Dropdown WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */

  import type { Component } from "./types/webcomponent.type";

  let { id = "", open = false, position, list = [] }: Component = $props();

  type stringinput = "" | "yes" | "no" | undefined;
  $effect(() => {
    console.log(open);

    if (!id) id = "";
    if (!position) {
      if ($host()?.style?.float && $host().style.float === "right")
        position = "right";
      else position = "left";
    }

    if (
      (open as unknown as stringinput) === "yes" ||
      (open as unknown as stringinput) === "" ||
      open === true
    )
      open = true;
    else open = false;

    try {
      if (list && !list[0]?.key) list = JSON.parse(list as unknown as string);
      else if (!list) list = [];
    } catch (err) {
      list = [];
    }
  });

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }
  function switchDown() {
    open = !open;
    dispatch("dropdownSwitch", {
      open,
      id,
    });
  }
  function clickMenu(key: string) {
    dispatch("dropDownClick", {
      key,
    });
    switchDown();
  }
</script>

<div
  class="dropdown"
  class:is-active={open}
  class:is-right={position === "right"}
  part="dropdown"
>
  <div class="dropdown-trigger">
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <div
      class="is-clickable"
      part="dropdownbutton"
      onclick={switchDown}
    >
      <slot name="dropdownbutton">btn</slot>
    </div>
  </div>
  <div class="dropdown-menu" part="dropdowncontent">
    <div class="dropdown-content">
      {#each list as listItem, listIndex (listIndex)}
        {#if listItem.linkHref}
          <a href={listItem.linkHref} class="dropdown-item">{listItem.label}</a>
        {:else}
          <!-- svelte-ignore a11y_click_events_have_key_events -->
          <!-- svelte-ignore a11y_no_static_element_interactions -->
          <div
            class="dropdown-item is-clickable"
            onclick={() => clickMenu(listItem.key)}
          >
            {listItem.label}
          </div>
        {/if}
      {/each}
    </div>
  </div>
</div>

<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
